export default __webpack_public_path__ + "static/media/kwf-logo-rgb.8a47927c.png";